import { Account } from 'app/modules/main/models/account';

export interface Access {

  readonly userId: string,
  readonly scopes: string[],

  readonly token: string,
  readonly expires: string,

}

export interface Authorization<A extends Account> extends Access {

  readonly account?: A,

}

export enum ErrorMessage {

  NOT_AUTHENTICATED = 'Not Authenticated',
  NOT_AUTHORISED = 'Not Authorised',

}
